import React from 'react'
import { images } from 'Assets/Images'
import { usePrinterContext } from 'state/context/PrinterTemplatesContext'
import { FormatMoney } from 'Utils/functions'
import { disclaimers } from 'Views/PrinterPreview/constants'
import { formatStartEndDate } from 'Utils/Helpers/formatDate'
export const DEFAULT_VALUE = disclaimers.regularCmf2

const defTermValue = (startDate, endDate) =>
  `Promoción válida del ${formatStartEndDate(
    startDate,
    endDate
  )}. No aplica con otras promociones ni descuentos, precios no incluyen ITBMS. La tarjeta digital CMF es emitida por CM Financiera, S.A. (CMF). *Valor de cuota referencial, aplican condiciones. La responsabilidad de CMF se limita a los aspectos del crédito. Accede a www.cmf.com.pa para más información.`

export const Square6ToPrintCCmfOffer = ({ products, i }) => {
  const { templateRef, terms } = usePrinterContext()

  const prod1 = products?.content?.products?.[0]
  const prod2 = products?.content?.products?.[1] || {}
  const prodBasePrice1 = FormatMoney(prod1?.BasePrice || 0)
  const prodBasePrice2 = FormatMoney(prod2?.BasePrice || 0)
  const prod1Price = FormatMoney(prod1?.Price || 0)
  const prod2Price = FormatMoney(prod2?.Price || 0)

  const terms1 =
    terms?.find(term => term?.prodId === prod1?.ProductId)?.value ||
    defTermValue(prod1?.StartDate, prod1?.FinishDate)

  const terms2 =
    terms?.find(term => term?.prodId === prod2?.ProductId)?.value ||
    defTermValue(prod2?.StartDate, prod2?.FinishDate)

  return (
    <div style={{ width: '450px' }} ref={el => (templateRef.current[i] = el)}>
      <div
        key={products.page}
        data-testid="printer-preview-left-canvas-2"
        id="printer-preview-left-canvas-square-2"
        className="printer-preview-left-canvas-square-2">
        <div
          className="printer-preview-left-canvas-square-2-box"
          style={{
            height: '100%',
            top: '0',
          }}>
          <div className="printer-preview-left-content-body-square-2">
            <p className="printer-preview-body-title-cmf-rows-2">
              {prod1?.ProductName || ''}
            </p>
            <p className="printer-preview-body-sku-cmf-rows-2">
              {prod1?.Sku || ''}
            </p>
            {prod1?.BasePrice && (
              <div className="printer-preview-container-prices-rows-2">
                <div className="printer-preview-content-price">
                  <p
                    className="printer-preview-quote-1-rows-2"
                    style={{
                      alignSelf: 'end',
                      marginBottom: 3,
                    }}>
                    36 cuotas desde
                  </p>
                  <div
                    className="printer-preview-container-price"
                    style={{
                      position: 'absolute',
                      bottom: 0,
                      left: 84,
                    }}>
                    <p className="printer-preview-price-simbol-rows-2">$</p>
                    <p className="printer-preview-price-rows-2">
                      {FormatMoney(prod1?.cmfCredit || 0)?.split('.')?.[0] ||
                        ''}
                    </p>
                    <p className="printer-preview-price-mini-rows-2">
                      .
                      {FormatMoney(prod1?.cmfCredit || 0)?.split('.')?.[1] ||
                        '00'}
                    </p>
                  </div>
                </div>
                <div className="printer-preview-content-price">
                  <p className="printer-preview-quote-2-rows-2">
                    24 cuotas desde
                  </p>
                  <div className="printer-preview-container-price">
                    <p className="printer-preview-price-simbol-small-rows-2">
                      $
                    </p>
                    <p className="printer-preview-price-small-rows-2">
                      {FormatMoney(prod1?.cmfCredit24 || 0)?.split('.')?.[0] ||
                        ''}
                    </p>
                    <p className="printer-preview-price-small-mini-rows-2">
                      .
                      {FormatMoney(prod1?.cmfCredit24 || 0)?.split('.')?.[1] ||
                        '00'}
                    </p>
                  </div>
                </div>
                <div className="printer-preview-content-price">
                  <p className="printer-preview-quote-2-rows-2">
                    12 cuotas desde
                  </p>
                  <div className="printer-preview-container-price">
                    <p className="printer-preview-price-simbol-small-rows-2">
                      $
                    </p>
                    <p className="printer-preview-price-small-rows-2">
                      {FormatMoney(prod1?.cmfCredit12 || 0)?.split('.')?.[0] ||
                        ''}
                    </p>
                    <p className="printer-preview-price-small-mini-rows-2">
                      .
                      {FormatMoney(prod1?.cmfCredit12 || 0)?.split('.')?.[1] ||
                        '00'}
                    </p>
                  </div>
                </div>
              </div>
            )}
          </div>
          <div className="printer-preview-content-footer-square-2">
            <div
              className="printer-preview-footer-container-prices-offer-square-2
              printer-preview-footer-prices-dividers-square-2 printer-preview-footer-prices-dividers-square-2-offer"
              style={{ marginTop: -2 }}>
              <div className="printer-preview-footer-vertical-divider-square-2" />
              <div className="printer-preview-footer-container-price">
                <div className="printer-preview-price-before-square-2" />
                <p className="printer-preview-footer-square-2-price">Antes</p>
                <p className="printer-preview-square-2-price-small">
                  {'$' + prodBasePrice1}
                </p>
              </div>

              <div className="printer-preview-footer-container-price">
                <p className="printer-preview-footer-square-2-price">Ahora</p>
                <p className="printer-preview-square-2-price-small">
                  {'$' + prod1Price}
                </p>
              </div>
            </div>
            <div
              className="printer-preview-content-footer-input-wrapper template-terms-wrapper-to-remove"
              style={{ marginTop: 6 }}>
              <p
                className="printer-preview-left-content-footer-legal-2"
                style={{ background: 'transparent' }}>
                {terms1}
              </p>
            </div>
          </div>
        </div>
        <div
          className="printer-preview-left-canvas-square-2-box"
          style={{
            height: '100%',
            top: '50.5%',
          }}>
          <div className="printer-preview-left-content-body-square-2">
            <p
              className="printer-preview-body-title-cmf-rows-2"
              style={{ marginTop: 4 }}>
              {prod2?.ProductName || ''}
            </p>
            <p className="printer-preview-body-sku-cmf-rows-2">
              {prod2?.Sku || ''}
            </p>
            {prod2?.BasePrice && (
              <div className="printer-preview-container-prices-rows-2">
                <div className="printer-preview-content-price">
                  <p
                    className="printer-preview-quote-1-rows-2"
                    style={{
                      alignSelf: 'end',
                      marginBottom: 3,
                    }}>
                    36 cuotas desde
                  </p>
                  <div
                    className="printer-preview-container-price"
                    style={{
                      position: 'absolute',
                      bottom: 0,
                      left: 84,
                    }}>
                    <p className="printer-preview-price-simbol-rows-2">$</p>
                    <p className="printer-preview-price-rows-2">
                      {FormatMoney(prod2?.cmfCredit || 0)?.split('.')?.[0] ||
                        ''}
                    </p>
                    <p className="printer-preview-price-mini-rows-2">
                      .
                      {FormatMoney(prod2?.cmfCredit || 0)?.split('.')?.[1] ||
                        '00'}
                    </p>
                  </div>
                </div>
                <div className="printer-preview-content-price">
                  <p className="printer-preview-quote-2-rows-2">
                    24 cuotas desde
                  </p>
                  <div className="printer-preview-container-price">
                    <p className="printer-preview-price-simbol-small-rows-2">
                      $
                    </p>
                    <p className="printer-preview-price-small-rows-2">
                      {FormatMoney(prod2?.cmfCredit24 || 0)?.split('.')?.[0] ||
                        ''}
                    </p>
                    <p className="printer-preview-price-small-mini-rows-2">
                      .
                      {FormatMoney(prod2?.cmfCredit24 || 0)?.split('.')?.[1] ||
                        '00'}
                    </p>
                  </div>
                </div>
                <div className="printer-preview-content-price">
                  <p className="printer-preview-quote-2-rows-2">
                    12 cuotas desde
                  </p>
                  <div className="printer-preview-container-price">
                    <p className="printer-preview-price-simbol-small-rows-2">
                      $
                    </p>
                    <p className="printer-preview-price-small-rows-2">
                      {FormatMoney(prod2?.cmfCredit12 || 0)?.split('.')?.[0] ||
                        ''}
                    </p>
                    <p className="printer-preview-price-small-mini-rows-2">
                      .
                      {FormatMoney(prod2?.cmfCredit12 || 0)?.split('.')?.[1] ||
                        '00'}
                    </p>
                  </div>
                </div>
              </div>
            )}
          </div>
          <div className="printer-preview-content-footer-square-2">
            <div
              className="printer-preview-footer-container-prices-offer-square-2
              printer-preview-footer-prices-dividers-square-2 printer-preview-footer-prices-dividers-square-2-offer"
              style={{ marginTop: -2 }}>
              <div className="printer-preview-footer-vertical-divider-square-2" />
              <div className="printer-preview-footer-container-price">
                <div className="printer-preview-price-before-square-2" />
                <p className="printer-preview-footer-square-2-price">Antes</p>
                <p className="printer-preview-square-2-price-small">
                  {'$' + prodBasePrice2}
                </p>
              </div>

              <div className="printer-preview-footer-container-price">
                <p className="printer-preview-footer-square-2-price">Ahora</p>
                <p className="printer-preview-square-2-price-small">
                  {'$' + prod2Price}
                </p>
              </div>
            </div>
            <div
              className="printer-preview-content-footer-input-wrapper template-terms-wrapper-to-remove"
              style={{ marginTop: 4 }}>
              <p
                className="printer-preview-left-content-footer-legal-2"
                style={{ background: 'transparent' }}>
                {terms2}
              </p>
            </div>
          </div>
        </div>
        <img
          className="printer-preview-left-image"
          src={images.printer.templates.cochez.cmfOffer5Print}
          alt="template-preview"
          style={{ opacity: 0 }}
        />
      </div>
    </div>
  )
}
